import { Module } from "wrapper6";
import $ from "jquery";
import debounce from "debounce";
import ObjectFitPolyfill from '../utils/_object-fit-polyfill';

export default class FilterPosts extends Module {
    ready() {
        const OBJECT_FIT = new ObjectFitPolyfill();

        let FILTERS = '.post-filters li';
        let POST_WRAPPER = '#posts';
        let SAERCH_FIELD = '#search-field';
        let ACTIVEPAGENUMBER = '.pagination ul li.active';
        let PAGENUMBER = '.pagination ul li';

        $(PAGENUMBER).on('click', function(){
            $(PAGENUMBER+'.active').removeClass('active')
            $(this).addClass('active');
            handle();
        });

        $(FILTERS).on('click', function(){
            $(FILTERS+'.active').removeClass('active')
            $(this).addClass('active');
            handle();
        });

        $(SAERCH_FIELD).on('keyup', debounce(function(){
            handle();
        }, 200));

        function handle(){
            $(POST_WRAPPER).addClass('loading');
            let search = $(SAERCH_FIELD).val();
            let slug = $('.post-filters li.active').data('value');
            let page = $(ACTIVEPAGENUMBER).data('page');
            let taxonomy = $('.post-filters').data('taxonomy');
            let post_type = $('.post-filters').data('post-type');
            let ppp = $('.post-filters').data('per-page');

            // Set ajax data
            let data = {
                action: 'filter_posts',
                slug: slug,
                search: search,
                pn: page,
                template: card,
                taxonomy: taxonomy,
                post_type: post_type,
                ppp: ppp
            };

            // Ajax call
            $.post(main_theme_objects.ajax_url, data, function (response) {
                $(POST_WRAPPER).html(response.html);
                $(POST_WRAPPER).removeClass('loading');
                OBJECT_FIT.init();
            });
        }

    }
}